import React from 'react';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { DeviceType } from '../../../../../types/DeviceType';
import { StaticInstallmentsDescriptionView } from './view';

export interface StaticInstallmentsDescriptionProps {
  isSinglePaymentMethodOption?: boolean;
  deviceType?: DeviceType;
  methodName: PaymentMethod;
  amount: string;
  currency: string;
  intallmentsNumber: number;
  moreInfo: React.ReactNode;
  moreInfoSize?: {
    width: number | string;
    height: number | string;
  };
}

export interface StaticInstallmentsDescriptionState {
  isInfoModalOpen: boolean;
}

export class StaticInstallmentsDescription extends React.Component<
  StaticInstallmentsDescriptionProps,
  StaticInstallmentsDescriptionState
> {
  state: StaticInstallmentsDescriptionState = {
    isInfoModalOpen: false,
  };

  showMoreInfoModal = () => {
    this.setState({
      isInfoModalOpen: true,
    });
  };

  closeMoreInfoModal = () => {
    this.setState({
      isInfoModalOpen: false,
    });
  };

  render() {
    const {
      amount,
      currency,
      intallmentsNumber,
      methodName,
      deviceType,
      moreInfo,
      moreInfoSize,
      isSinglePaymentMethodOption,
    } = this.props;

    const fullAmount = Number(amount);
    const installmentAmount = Number(fullAmount / intallmentsNumber).toFixed(2);

    return (
      <StaticInstallmentsDescriptionView
        amount={installmentAmount}
        currency={currency}
        deviceType={deviceType}
        methodName={methodName}
        moreInfo={moreInfo}
        moreInfoSize={moreInfoSize}
        isInfoModalOpen={this.state.isInfoModalOpen}
        onMoreInfoClick={this.showMoreInfoModal}
        onCloseModal={this.closeMoreInfoModal}
        isSinglePaymentMethodOption={isSinglePaymentMethodOption}
      />
    );
  }
}
